module.exports = externalConfig;